import {
  gql 
} from "@apollo/client"

export const AccountInformationPageFragment = gql`
    fragment AccountInformationPageFragment on Customer {
        id
        firstname
        lastname
        email
        gender
        date_of_birth
        experience
        share_code
        level {
            next_level
            pre_level
            score
        }
        created_at
        couponCodes {
            code
            description
            from_date
            title
            to_date
            type
        }
        redeemPoints {
            code
            state
        }
    }
`
